import styles from '../../index.module.scss';
import KLevelField from './KLevelField';
import { useEffect } from 'react';
import { useFormContext } from 'react-hook-form';
import useIntakeBlockToggle, { intakeBlocksEnum } from '../../../../../hooks/useIntakeBlockToggle';
import ToggleRadioField from '../../../../../../../../Inputs/ToggleRadioField';
import { useTranslation } from 'react-i18next';
import { DEFAULT_NS } from '../../../../../../../../../i18n/types';
import { DEFAULT_TOGGLE_VALUE } from '../../../../../../../../Inputs/ToggleRadioField/options';

const OAndPFields = () => {
  const { isOn } = useIntakeBlockToggle();
  const isOPBlockEnabled = isOn(intakeBlocksEnum.o_and_p);
  const { setValue, control } = useFormContext();
  const { t } = useTranslation(DEFAULT_NS, {
    keyPrefix: 'profile.content.fields',
  });
  useEffect(() => {
    if (isOPBlockEnabled) {
      setValue('patientFeatureTags.prosthetic_flow', DEFAULT_TOGGLE_VALUE);
      setValue('patientFeatureTags.orthotic_flow', DEFAULT_TOGGLE_VALUE);
    }
  }, []);

  if (!isOPBlockEnabled) {
    return null;
  }

  return (
    <div className={styles.filedsWrapper}>
      <KLevelField />
      <div className="flex flex-col">
        <ToggleRadioField
          name="patientFeatureTags.prosthetic_flow"
          control={control}
          label={t('prosthesis')}
        />
        <ToggleRadioField
          name="patientFeatureTags.orthotic_flow"
          control={control}
          label={t('orthosis')}
          classes={{
            root: 'pb-[0.6875rem]',
          }}
        />
      </div>
    </div>
  );
};
export default OAndPFields;
